export const PAYMENT_OPTION_TYPE = {
  'SKRILL': 'SKRILL', 
  'NETELLER': 'NETELLER',
  'ECOPAYZ': 'ECOPAYZ',
  'BITCOIN': 'BITCOIN',
  'BANK': 'BANK',
};

export function makePaymentOption(payload) {
  return PaymentOption.fromPayload(payload);
}

export class PaymentOptionDisplay {
  constructor() {
    this._fields = [];
    this._extras = null;
    this._paymentMethods = {};
  }

  static fromPayload(payload) {
    let paymentOptionDisplay = new PaymentOptionDisplay();

    paymentOptionDisplay.fields = payload.fields;
    paymentOptionDisplay.extras = payload.extras;
    paymentOptionDisplay._paymentMethods = payload.paymentMethods;

    return paymentOptionDisplay;
  }

  get logo() {
    return this._logo;
  }

  set description(description) {
    this._description = this.description;
  }

  get description() {
    return this._description;
  }

  set fields(fields) {
    this._fields = fields;
  }

  get fields() {
    return this._fields;
  }

  set paymentMethods(paymentMethods) {
    this._paymentMethods = paymentMethods;
  }

  get paymentMethods() {
    return this._paymentMethods;
  }

  set extras(extras) {
    this._extras = extras;
  }

  get extras() {
    return this._extras;
  }

  get logo() {
    return this._extras.logo;
  }

  get description() {
    return this._extras.description;
  }

  get selected() {
    return this._extras.selected;
  }
}

export class PaymentOption {
  constructor() {
    this._id = null;
    this._isActive = false;
    this._type = null;
    this._fields = {};
    this._display = null;
  }

  static fromPayload(payload) {
    const paymentOption = new PaymentOption();

    paymentOption.id = payload.id;
    paymentOption.isActive = payload.is_active;
    paymentOption.type = payload.type;
    paymentOption.fields = payload.fields;
  
    if (payload.details) {
      paymentOption.display = PaymentOptionDisplay.fromPayload(payload.details.display);

    }
  
    return paymentOption;
  }

  set id(id) {
    this._id = id;
  }

  get id() {
    return this._id;
  }

  set isActive(isActive) {
    this._isActive = isActive;
  }

  get isActive() {
    return this._isActive;
  }

  set type(type) {
    this._type = type;
  }

  get type() {
    return this._type;
  }

  set fields(fields) {
    this._fields = fields;
  }

  get fields() {
    return this._fields;
  }

  set display(display) {
    this._display = display;
  }

  get display() {
    return this._display;
  }
}



// WEBPACK FOOTER //
// ./client/app/api/models/payment-option.model.js